export default [
  {
    // 路由写好注释： 栏目 + 文件名 + 页面名
    path: '/plan',
    component: resolve => require(['./view/Index'], resolve),
    redirect: '/plan/channelPlan',
    children: [
   {
    // 渠道计划
    path: 'channelPlan',
    component: resolve => require(['./view/channelPlan/Index'], resolve),
    // meta: {
    //   noSideBar: false
    // }
  },
  {
    // 加入渠道计划
    path: 'channelPlan/JoinPlan',
    component: resolve => require(['./view/channelPlan/JoinPlan'], resolve),
    meta: {
      parent:"/plan/channelPlan"
    }
  },
  {
    // 已申请渠道计划
    path: 'channelPlanApply',
    component: resolve => require(['./view/channelPlanApply/Index'], resolve),
  },
  {
    // 已申请渠道计划 详情
    path: 'ApplyDetails',
    component: resolve => require(['./view/channelPlanApply/ApplyDetails'], resolve),
    meta: {
      parent:"/plan/channelPlanApply"
    }
  },
  {
    //已加入伙伴计划
    path: 'protocol/index',
    component: resolve => require(['./view/protocol/Index'], resolve),
    meta:{
      keepAlive: true
    }
  },
  {
    // 已加入伙伴计划 详情
    path: 'JoinDetails',
    component: resolve => require(['./view/channelPlanApply/JoinDetails'], resolve),
    meta: {
      parent:"/plan/protocol/index"
    }
  },
  {
    // 路由写好注释： 栏目 + 文件名 + 页面名
    //协议列表 更误
    path: 'protocol/accident',
    component: resolve => require(['./view/protocol/accident'], resolve),
    meta: {
      parent: "/plan/policy/index"
    }
  },
  {
    // 伙伴政策
    path: 'policy/index',
    component: resolve => require(['./view/policy/Index'], resolve),
  }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/plan/router.js